import installer from './defaults';
export * from './packages';
export { default } from './defaults';
export const install = installer.install;
